export function format(value) {
  return Number(value).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL"
  });
}
